/**
 * Auth API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NevisStatusRequest { 
    statusToken: string;
    appStatus: NevisStatusRequest.AppStatusEnum;
}
export namespace NevisStatusRequest {
    export const AppStatusEnum = {
        SUCCESS: 'success',
        ERROR: 'error',
        CANCEL: 'cancel',
        NA: 'na'
    } as const;
    export type AppStatusEnum = typeof AppStatusEnum[keyof typeof AppStatusEnum];
}


